export const DISCOUNT_SUCCESS_MESSAGE = 'Your discount has been automatically applied to checkout'
export const GENERAL_ERROR_MESSAGE = 'An unknown error occurred. Please try again or contact support if this continues.'
